const appName = 'app';
const prefix = process.env.GATSBY_PREFIX || '';

const domain =
  process.env.GATSBY_DOMAIN ||
  'https://api.nomox.it' ||
  'http://localhost:8000';

const sso_domain = process.env.GATSBY_SSO_DOMAIN || 'https://sso.nomox.it';

const irnerioDocumentsProvider =
  'https://ke8uqcbh54.execute-api.eu-west-1.amazonaws.com/prd';
const dueDiligenceProvider =
  'https://nsa82zpx0c.execute-api.eu-west-1.amazonaws.com/prd';

const gestionaleProvider =
  process.env.GATSBY_GESIONALE_PROVIDER ||
  // 'https://ab2wzhb0mb.execute-api.eu-west-1.amazonaws.com/stg' ||
  // 'https://byyhyygmea.execute-api.eu-west-1.amazonaws.com/prd' ||
  'http://localhost:3000';

const generalProvider =
  process.env.GATSBY_GESIONALE_PROVIDER ||
  // 'https://ab2wzhb0mb.execute-api.eu-west-1.amazonaws.com/stg' ||
  // 'https://byyhyygmea.execute-api.eu-west-1.amazonaws.com/prd' ||
  'http://localhost:3000';

export const creditiMap = {
  pec: 0.5,
  visuraCatastale: 3,
  visuraIpocatastale: 30,
};

export const rootConfig = {
  isDebug: !process.env.GATSBY_DOMAIN,
  language: 'it',
  url: `${domain}/api`,
  irnerioDocumentsProvider: `${irnerioDocumentsProvider}`,
  urlDueDiligence: `${dueDiligenceProvider}`,
  beEndpoint: `${generalProvider}`,
  endpointDrive: `${gestionaleProvider}/drive`,
  endpointMessages: `${gestionaleProvider}/messages`,
  endpointDriveDownload: `${gestionaleProvider}/drive-download`,
  endpointGestionale: `${gestionaleProvider}/gestionale`,
  app_base_path: `/${appName}`,
  app_path: `${prefix}/${appName}`,
  upload_url: `${domain}/api/uploadAudio.php`,
  audio_folder: `${domain}/api/uploads/audio/`,
  base_url: `${domain}`,
  wp_url: `${domain}/?rest_route=`,
  sso_endpoint: `${sso_domain}/realms/nomox/protocol/openid-connect`,
  sso_client_id: `nomox${
    process.env.GATSBY_STAGE === 'prd' ? '' : `-${process.env.GATSBY_STAGE}`
  }`,
  endpointWpGestionale: `${domain}/?rest_route=/gestionale/v1`,
  modalTimeout: 600,
  stage: process.env.GATSBY_STAGE,
  pageSize: 10,
  populateFields: 10,
  innerPageSize: '95%',
  irnerioFeUrl: process.env.GATSBY_FE_URL_IRNERIO,
};
